// Google Analytics 4, added as a second destination on the Google tag that public/index.html
// already loads for Google Ads. No extra script is injected and no library is added.
//
// Entirely optional: with REACT_APP_GA4_MEASUREMENT_ID unset, every function here is a no-op and
// the site behaves exactly as before. Automatic page views are disabled and one page_view is sent
// per route instead, so SPA navigation is counted once. Nothing identifying a person is sent: no
// emails, names, form contents or full affiliate query strings.
const GA4_ID = (process.env.REACT_APP_GA4_MEASUREMENT_ID || "").trim();

let configured = false;

export const ga4Enabled = () => Boolean(GA4_ID);

export const initGa4 = () => {
  if (!GA4_ID || configured || typeof window.gtag !== "function") return;
  configured = true;
  window.gtag("config", GA4_ID, {
    send_page_view: false,
    allow_google_signals: false,
    allow_ad_personalization_signals: false,
  });
};

export const ga4PageView = () => {
  if (!GA4_ID || typeof window.gtag !== "function") return;
  window.gtag("event", "page_view", {
    send_to: GA4_ID,
    page_title: document.title,
    page_location: window.location.href,
  });
};

// Outbound affiliate click. Reported as an interest signal, never as a purchase: a click is not a
// commission. The destination is reduced to host + path so merchant tracking parameters are not
// copied into analytics.
export const ga4AffiliateClick = ({ merchant, destination, placement }) => {
  if (!GA4_ID || typeof window.gtag !== "function") return;
  let host = "";
  let path = "";
  try {
    const url = new URL(destination, window.location.href);
    host = url.host;
    path = url.pathname;
  } catch {
    return;
  }
  window.gtag("event", "affiliate_click", {
    send_to: GA4_ID,
    merchant: String(merchant || host).slice(0, 100),
    destination_host: host.slice(0, 100),
    destination_path: path.slice(0, 180),
    placement: String(placement || "unknown").slice(0, 100),
    page_path: window.location.pathname.slice(0, 180),
  });
};
